import React from 'react';
import CampaignMonitorForm from '../../CampaignMonitorForm/CampaignMonitorForm';

const EmailFormCM = (props) => (
    <div>
        <CampaignMonitorForm successSubmit={props.successSubmit} />
    </div>
)
export default EmailFormCM;